import Axios from "axios";
import { environment } from "src/environment";
import type { RootStoreInstance } from "~/mobx/RootStore";
import { createCheckAndRefreshTokenInterceptor } from "./checkAndRefreshToken.interceptor";
import { errorLogger } from "./errorLogger.interceptor";
import { requestLogger } from "./requestLogger.interceptor";
import { responseLogger } from "./responseLogger.interceptor";

export function createBaseAuthHttp(
  getStore: () => RootStoreInstance,
  axios = Axios,
) {
  const http = axios.create({
    baseURL: environment.BASE_URL,
  });

  const checkAndRefreshToken = createCheckAndRefreshTokenInterceptor(getStore);

  http.interceptors.request.use(checkAndRefreshToken);
  http.interceptors.request.use(requestLogger);
  http.interceptors.response.use(responseLogger, errorLogger);

  return http;
}

export interface HttpStatic extends ReturnType<typeof createBaseAuthHttp> {}
